import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route
} from 'react-router-dom';
import Login from './pages/Login';
import Customers from './pages/Customers';
import Project from './pages/Project';
import PrivateRoute from './utils/PrivateRoute';
import TimeEntries from './pages/TimeEntries';
import Layout from './components/Layout';
import Settings from "./pages/Settings";
import EmployeeArea from "./pages/EmployeeArea";
import ProjectAcquisition from './pages/ProjectAcquisition';
import Contacts from "./pages/Contacts";
import KPI from "./pages/KPI";
import EmployeeProfiles from "./pages/EmployeeProfiles";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login/>}/>

                <Route path="/customers" element={
                    <PrivateRoute>
                        <Layout>
                            <Customers/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/kpi" element={
                    <PrivateRoute>
                        <Layout>
                            <KPI/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/employee_profile" element={
                    <PrivateRoute>
                        <Layout>
                            <EmployeeProfiles/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/projects" element={
                    <PrivateRoute>
                        <Layout>
                            <Project/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/project_acquisition" element={
                    <PrivateRoute>
                        <Layout>
                            <ProjectAcquisition/>
                        </Layout>
                    </PrivateRoute>
                }/>
                <Route path="/customer_contacts" element={
                    <PrivateRoute>
                        <Layout>
                            <Contacts/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/timeentries" element={
                    <PrivateRoute>
                        <Layout>
                            <TimeEntries/>
                        </Layout>
                    </PrivateRoute>
                }/>
                <Route path="/employee" element={
                    <PrivateRoute>
                        <Layout>
                            <EmployeeArea/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/settings" element={
                    <PrivateRoute>
                        <Layout>
                            <Settings/>
                        </Layout>
                    </PrivateRoute>
                }/>
            </Routes>
        </BrowserRouter>
    );
}
